/**
 * Base de Datos de Alimentos Mexicanos
 * Sistema de Equivalentes Mexicano según NOM
 *
 * Basado en el Sistema Mexicano de Alimentos Equivalentes (SMAE)
 * Adaptado para la cultura alimentaria de México
 */

// Categorías de equivalentes mexicanos
export const CATEGORIAS_EQUIVALENTES = {
  CEREALES_SIN_GRASA: 'cereales_sin_grasa',
  CEREALES_CON_GRASA: 'cereales_con_grasa',
  LEGUMINOSAS: 'leguminosas',
  VERDURAS: 'verduras',
  FRUTAS: 'frutas',
  LECHE_DESCREMADA: 'leche_descremada',
  LECHE_SEMIDESCREMADA: 'leche_semidescremada',
  LECHE_ENTERA: 'leche_entera',
  CARNES_MUY_BAJO: 'carnes_muy_bajo_aporte',
  CARNES_BAJO: 'carnes_bajo_aporte',
  CARNES_MODERADO: 'carnes_moderado_aporte',
  CARNES_ALTO: 'carnes_alto_aporte',
  GRASAS_SIN_PROTEINA: 'grasas_sin_proteina',
  GRASAS_CON_PROTEINA: 'grasas_con_proteina',
  AZUCARES_SIN_GRASA: 'azucares_sin_grasa',
  AZUCARES_CON_GRASA: 'azucares_con_grasa',
  BEBIDA_LIBRE: 'bebida_libre',
};

// Regiones de México
export const REGIONES_MEXICO = [
  'Todo México',
  'Norte',
  'Centro',
  'Sur',
  'Golfo',
  'Pacífico',
  'Península de Yucatán',
  'Ciudad de México',
  'Oaxaca',
  'Veracruz',
  'Jalisco',
  'Puebla',
];

// Base de datos de alimentos mexicanos (inicio con 50 emblemáticos)
export const ALIMENTOS_MEXICANOS = [
  // ========== CEREALES SIN GRASA ==========
  {
    id: 'alimento_001',
    nombre: 'Tortilla de maíz',
    nombres_regionales: ['Tortilla', 'Tlaxcalli (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_SIN_GRASA,
    cantidad_porcion: '1 pieza (30g)',
    calorias: 64,
    proteina_g: 1.5,
    carbohidratos_g: 13.8,
    grasa_g: 0.9,
    fibra_g: 1.5,
    calcio_mg: 45,
    hierro_mg: 0.6,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 8,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 52,
    carga_glucemica: 7,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/tortilla-maiz.jpg',
    sustitutos_similares: ['alimento_002', 'alimento_003'],
    descripcion: 'Alimento básico prehispánico, patrimonio cultural de México. Base de la alimentación tradicional.',
  },
  {
    id: 'alimento_002',
    nombre: 'Tortilla de harina integral',
    nombres_regionales: ['Tortilla de harina', 'Sobaquera (Sonora)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_SIN_GRASA,
    cantidad_porcion: '1 pieza pequeña (30g)',
    calorias: 78,
    proteina_g: 2.1,
    carbohidratos_g: 14.2,
    grasa_g: 1.5,
    fibra_g: 2.0,
    calcio_mg: 12,
    hierro_mg: 0.8,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 12,
    es_tradicional_mexicano: true,
    region_origen: ['Norte'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 30,
    carga_glucemica: 4,
    potencial_alergeno: ['gluten'],
    imagen_url: '/images/alimentos/tortilla-harina.jpg',
    sustitutos_similares: ['alimento_001'],
    descripcion: 'Típica del norte de México, especialmente Sonora. Versión integral más nutritiva.',
  },
  {
    id: 'alimento_003',
    nombre: 'Tostadas horneadas',
    nombres_regionales: ['Tostadas'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_SIN_GRASA,
    cantidad_porcion: '2 piezas (30g)',
    calorias: 120,
    proteina_g: 2.5,
    carbohidratos_g: 24.0,
    grasa_g: 1.2,
    fibra_g: 2.0,
    calcio_mg: 50,
    hierro_mg: 1.0,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 10,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 70,
    carga_glucemica: 17,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/tostadas.jpg',
    sustitutos_similares: ['alimento_001'],
    descripcion: 'Tortillas deshidratadas, base para muchos platillos mexicanos.',
  },

  // ========== LEGUMINOSAS ==========
  {
    id: 'alimento_010',
    nombre: 'Frijoles negros cocidos',
    nombres_regionales: ['Frijol', 'Frijol de olla', 'Etl (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LEGUMINOSAS,
    cantidad_porcion: '1/2 taza (90g)',
    calorias: 114,
    proteina_g: 7.6,
    carbohidratos_g: 20.4,
    grasa_g: 0.5,
    fibra_g: 7.5,
    calcio_mg: 23,
    hierro_mg: 1.8,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 128,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 30,
    carga_glucemica: 6,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/frijoles-negros.jpg',
    sustitutos_similares: ['alimento_011', 'alimento_012'],
    descripcion: 'Alimento básico prehispánico, parte del trío sagrado maíz-frijol-calabaza. Rico en proteína vegetal y fibra.',
  },
  {
    id: 'alimento_011',
    nombre: 'Frijoles pintos cocidos',
    nombres_regionales: ['Frijol pinto', 'Frijol bayo'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LEGUMINOSAS,
    cantidad_porcion: '1/2 taza (90g)',
    calorias: 122,
    proteina_g: 7.7,
    carbohidratos_g: 22.4,
    grasa_g: 0.6,
    fibra_g: 7.7,
    calcio_mg: 39,
    hierro_mg: 1.8,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 1,
    folato_mcg: 147,
    es_tradicional_mexicano: true,
    region_origen: ['Norte', 'Centro'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 39,
    carga_glucemica: 9,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/frijoles-pintos.jpg',
    sustitutos_similares: ['alimento_010'],
    descripcion: 'Variedad popular en el norte de México. Excelente fuente de proteína y minerales.',
  },
  {
    id: 'alimento_012',
    nombre: 'Lentejas cocidas',
    nombres_regionales: ['Lenteja'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LEGUMINOSAS,
    cantidad_porcion: '1/2 taza (100g)',
    calorias: 116,
    proteina_g: 9.0,
    carbohidratos_g: 20.0,
    grasa_g: 0.4,
    fibra_g: 7.9,
    calcio_mg: 19,
    hierro_mg: 3.3,
    vitamina_a_mcg: 8,
    vitamina_c_mg: 1.5,
    folato_mcg: 181,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 32,
    carga_glucemica: 6,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/lentejas.jpg',
    sustitutos_similares: ['alimento_010', 'alimento_011'],
    descripcion: 'Leguminosa rica en hierro y folato, ideal para prevenir anemia.',
  },

  // ========== VERDURAS ==========
  {
    id: 'alimento_020',
    nombre: 'Nopal asado',
    nombres_regionales: ['Nopal', 'Nopalli (náhuatl)', 'Penca de nopal'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza (150g)',
    calorias: 23,
    proteina_g: 2.0,
    carbohidratos_g: 4.9,
    grasa_g: 0.1,
    fibra_g: 3.0,
    calcio_mg: 164,
    hierro_mg: 0.6,
    vitamina_a_mcg: 58,
    vitamina_c_mg: 9.3,
    folato_mcg: 3,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 7,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/nopal.jpg',
    sustitutos_similares: ['alimento_021', 'alimento_022'],
    descripcion: 'Símbolo nacional de México, superalimento prehispánico. Ayuda a controlar glucosa y colesterol.',
  },
  {
    id: 'alimento_021',
    nombre: 'Chayote cocido',
    nombres_regionales: ['Chayote', 'Guatila', 'Tayota'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza (160g)',
    calorias: 38,
    proteina_g: 1.4,
    carbohidratos_g: 8.9,
    grasa_g: 0.6,
    fibra_g: 3.5,
    calcio_mg: 29,
    hierro_mg: 0.5,
    vitamina_a_mcg: 10,
    vitamina_c_mg: 12.8,
    folato_mcg: 123,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Sur'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/chayote.jpg',
    sustitutos_similares: ['alimento_020'],
    descripcion: 'Verdura tradicional mexicana, muy versátil en la cocina.',
  },
  {
    id: 'alimento_022',
    nombre: 'Flor de calabaza',
    nombres_regionales: ['Flor de calabaza', 'Guías'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza (100g)',
    calorias: 15,
    proteina_g: 1.0,
    carbohidratos_g: 3.3,
    grasa_g: 0.1,
    fibra_g: 1.0,
    calcio_mg: 70,
    hierro_mg: 0.3,
    vitamina_a_mcg: 155,
    vitamina_c_mg: 7.0,
    folato_mcg: 47,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Sur'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'moderado',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/flor-calabaza.jpg',
    sustitutos_similares: ['alimento_020'],
    descripcion: 'Flor comestible muy apreciada en la cocina mexicana, rica en antioxidantes.',
  },

  // ========== FRUTAS ==========
  {
    id: 'alimento_030',
    nombre: 'Papaya maradol',
    nombres_regionales: ['Papaya', 'Lechosa'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '1 taza en cubos (140g)',
    calorias: 55,
    proteina_g: 0.9,
    carbohidratos_g: 13.7,
    grasa_g: 0.3,
    fibra_g: 2.5,
    calcio_mg: 34,
    hierro_mg: 0.4,
    vitamina_a_mcg: 95,
    vitamina_c_mg: 85.5,
    folato_mcg: 53,
    es_tradicional_mexicano: true,
    region_origen: ['Sur', 'Golfo', 'Pacífico'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 60,
    carga_glucemica: 8,
    potencial_alergeno: ['latex (sensibilidad cruzada)'],
    imagen_url: '/images/alimentos/papaya.jpg',
    sustitutos_similares: ['alimento_031'],
    descripcion: 'Fruta tropical mexicana rica en enzima papaína, ayuda a la digestión.',
  },
  {
    id: 'alimento_031',
    nombre: 'Mango ataulfo',
    nombres_regionales: ['Mango', 'Mango manila'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '1/2 pieza mediana (100g)',
    calorias: 60,
    proteina_g: 0.8,
    carbohidratos_g: 15.0,
    grasa_g: 0.4,
    fibra_g: 1.6,
    calcio_mg: 11,
    hierro_mg: 0.2,
    vitamina_a_mcg: 54,
    vitamina_c_mg: 36.4,
    folato_mcg: 43,
    es_tradicional_mexicano: true,
    region_origen: ['Sur', 'Golfo'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'moderado',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 51,
    carga_glucemica: 8,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/mango.jpg',
    sustitutos_similares: ['alimento_030'],
    descripcion: 'Mango mexicano de exportación, muy dulce y aromático.',
  },

  // ========== GRASAS CON PROTEÍNA ==========
  {
    id: 'alimento_040',
    nombre: 'Aguacate hass',
    nombres_regionales: ['Aguacate', 'Avocado', 'Ahuacatl (náhuatl)', 'Palta'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_CON_PROTEINA,
    cantidad_porcion: '1/3 pieza mediana (50g)',
    calorias: 80,
    proteina_g: 1.0,
    carbohidratos_g: 4.3,
    grasa_g: 7.3,
    fibra_g: 3.4,
    calcio_mg: 6,
    hierro_mg: 0.3,
    vitamina_a_mcg: 7,
    vitamina_c_mg: 5.0,
    folato_mcg: 41,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: ['latex (sensibilidad cruzada)'],
    imagen_url: '/images/alimentos/aguacate.jpg',
    sustitutos_similares: [],
    descripcion: 'Superalimento mexicano, rico en grasas monoinsaturadas y vitaminas. Oro verde de México.',
  },
  {
    id: 'alimento_041',
    nombre: 'Pepitas de calabaza tostadas',
    nombres_regionales: ['Pepitas', 'Semillas de calabaza'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_CON_PROTEINA,
    cantidad_porcion: '2 cucharadas (20g)',
    calorias: 114,
    proteina_g: 5.0,
    carbohidratos_g: 3.0,
    grasa_g: 9.6,
    fibra_g: 1.1,
    calcio_mg: 9,
    hierro_mg: 2.3,
    vitamina_a_mcg: 1,
    vitamina_c_mg: 0.3,
    folato_mcg: 12,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 25,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/pepitas.jpg',
    sustitutos_similares: ['alimento_040'],
    descripcion: 'Semillas prehispánicas ricas en zinc y magnesio, excelentes para la salud prostática.',
  },

  // ========== BEBIDAS LIBRES ==========
  {
    id: 'alimento_050',
    nombre: 'Agua de jamaica sin azúcar',
    nombres_regionales: ['Agua de jamaica', 'Jamaica'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.BEBIDA_LIBRE,
    cantidad_porcion: '1 vaso (240ml)',
    calorias: 0,
    proteina_g: 0,
    carbohidratos_g: 0,
    grasa_g: 0,
    fibra_g: 0,
    calcio_mg: 0,
    hierro_mg: 0,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 0,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/agua-jamaica.jpg',
    sustitutos_similares: ['alimento_051'],
    descripcion: 'Bebida tradicional mexicana rica en antioxidantes, ayuda a bajar la presión arterial.',
  },
  {
    id: 'alimento_051',
    nombre: 'Agua de horchata light (sin azúcar)',
    nombres_regionales: ['Horchata', 'Agua de horchata'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.BEBIDA_LIBRE,
    cantidad_porcion: '1 vaso (240ml)',
    calorias: 15,
    proteina_g: 0.2,
    carbohidratos_g: 3.5,
    grasa_g: 0.1,
    fibra_g: 0.3,
    calcio_mg: 65,
    hierro_mg: 0.3,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 0,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/horchata.jpg',
    sustitutos_similares: ['alimento_050'],
    descripcion: 'Bebida refrescante mexicana a base de arroz y canela, versión sin azúcar.',
  },

  // ========== MÁS CEREALES SIN GRASA ==========
  {
    id: 'alimento_004',
    nombre: 'Amaranto tostado',
    nombres_regionales: ['Amaranto', 'Alegría (en dulce)', 'Huautli (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_SIN_GRASA,
    cantidad_porcion: '3 cucharadas (25g)',
    calorias: 95,
    proteina_g: 3.5,
    carbohidratos_g: 16.8,
    grasa_g: 1.8,
    fibra_g: 2.0,
    calcio_mg: 47,
    hierro_mg: 2.1,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 1.3,
    folato_mcg: 22,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Sur'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 35,
    carga_glucemica: 6,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/amaranto.jpg',
    sustitutos_similares: ['alimento_001'],
    descripcion: 'Pseudocereal prehispánico, alimento sagrado de los aztecas. Rico en proteína y calcio.',
  },
  {
    id: 'alimento_005',
    nombre: 'Elote (maíz) hervido',
    nombres_regionales: ['Elote', 'Jilote', 'Choclo'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_SIN_GRASA,
    cantidad_porcion: '1/2 pieza mediana (90g)',
    calorias: 77,
    proteina_g: 2.9,
    carbohidratos_g: 17.1,
    grasa_g: 1.1,
    fibra_g: 2.4,
    calcio_mg: 2,
    hierro_mg: 0.5,
    vitamina_a_mcg: 9,
    vitamina_c_mg: 6.8,
    folato_mcg: 42,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 48,
    carga_glucemica: 8,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/elote.jpg',
    sustitutos_similares: ['alimento_001'],
    descripcion: 'Maíz tierno, parte esencial de la cultura alimentaria mexicana. Fuente de fibra y antioxidantes.',
  },
  {
    id: 'alimento_006',
    nombre: 'Pan integral mexicano',
    nombres_regionales: ['Bolillo integral', 'Telera integral'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_SIN_GRASA,
    cantidad_porcion: '1 pieza pequeña (30g)',
    calorias: 75,
    proteina_g: 2.5,
    carbohidratos_g: 13.5,
    grasa_g: 1.2,
    fibra_g: 2.5,
    calcio_mg: 15,
    hierro_mg: 0.9,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 15,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 51,
    carga_glucemica: 7,
    potencial_alergeno: ['gluten'],
    imagen_url: '/images/alimentos/pan-integral.jpg',
    sustitutos_similares: ['alimento_001', 'alimento_002'],
    descripcion: 'Versión integral del pan mexicano tradicional, mayor contenido de fibra.',
  },

  // ========== MÁS LEGUMINOSAS ==========
  {
    id: 'alimento_013',
    nombre: 'Garbanzos cocidos',
    nombres_regionales: ['Garbanzo'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LEGUMINOSAS,
    cantidad_porcion: '1/2 taza (82g)',
    calorias: 135,
    proteina_g: 7.3,
    carbohidratos_g: 22.5,
    grasa_g: 2.1,
    fibra_g: 6.2,
    calcio_mg: 40,
    hierro_mg: 2.4,
    vitamina_a_mcg: 2,
    vitamina_c_mg: 1.3,
    folato_mcg: 141,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 28,
    carga_glucemica: 6,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/garbanzos.jpg',
    sustitutos_similares: ['alimento_010', 'alimento_011'],
    descripcion: 'Leguminosa versátil, excelente fuente de proteína vegetal y fibra soluble.',
  },
  {
    id: 'alimento_014',
    nombre: 'Habas cocidas',
    nombres_regionales: ['Haba', 'Haba verde'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LEGUMINOSAS,
    cantidad_porcion: '1/2 taza (85g)',
    calorias: 94,
    proteina_g: 6.5,
    carbohidratos_g: 16.7,
    grasa_g: 0.4,
    fibra_g: 5.4,
    calcio_mg: 18,
    hierro_mg: 1.3,
    vitamina_a_mcg: 2,
    vitamina_c_mg: 0.5,
    folato_mcg: 88,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Sur'],
    temporada: ['Primavera'],
    costo_relativo: 'economico',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 40,
    carga_glucemica: 7,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/habas.jpg',
    sustitutos_similares: ['alimento_010'],
    descripcion: 'Leguminosa tradicional mexicana, rica en proteínas y vitaminas del complejo B.',
  },

  // ========== MÁS VERDURAS ==========
  {
    id: 'alimento_023',
    nombre: 'Calabacita italiana',
    nombres_regionales: ['Calabacita', 'Zucchini', 'Calabaza tierna'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza (180g)',
    calorias: 31,
    proteina_g: 2.4,
    carbohidratos_g: 6.1,
    grasa_g: 0.6,
    fibra_g: 2.0,
    calcio_mg: 29,
    hierro_mg: 0.7,
    vitamina_a_mcg: 38,
    vitamina_c_mg: 31.2,
    folato_mcg: 40,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/calabacita.jpg',
    sustitutos_similares: ['alimento_020', 'alimento_021'],
    descripcion: 'Verdura muy popular en cocina mexicana, baja en calorías y versátil.',
  },
  {
    id: 'alimento_024',
    nombre: 'Jitomate (tomate rojo)',
    nombres_regionales: ['Jitomate', 'Tomate', 'Xitomatl (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza picado (180g)',
    calorias: 32,
    proteina_g: 1.6,
    carbohidratos_g: 7.0,
    grasa_g: 0.4,
    fibra_g: 2.2,
    calcio_mg: 18,
    hierro_mg: 0.5,
    vitamina_a_mcg: 75,
    vitamina_c_mg: 24.7,
    folato_mcg: 27,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/jitomate.jpg',
    sustitutos_similares: ['alimento_020'],
    descripcion: 'Originario de México, base de la salsa mexicana. Rico en licopeno antioxidante.',
  },
  {
    id: 'alimento_025',
    nombre: 'Chile poblano',
    nombres_regionales: ['Chile poblano', 'Chile para rellenar', 'Chile ancho (seco)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 pieza mediana (100g)',
    calorias: 20,
    proteina_g: 1.0,
    carbohidratos_g: 4.6,
    grasa_g: 0.2,
    fibra_g: 2.0,
    calcio_mg: 11,
    hierro_mg: 0.4,
    vitamina_a_mcg: 54,
    vitamina_c_mg: 80.4,
    folato_mcg: 17,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Puebla'],
    temporada: ['Verano', 'Otoño'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/chile-poblano.jpg',
    sustitutos_similares: [],
    descripcion: 'Chile emblemático mexicano, rico en vitamina C. Base de chiles en nogada.',
  },
  {
    id: 'alimento_026',
    nombre: 'Quelites (quintoniles)',
    nombres_regionales: ['Quelites', 'Quintoniles', 'Verdolagas', 'Quilitl (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza cocida (160g)',
    calorias: 23,
    proteina_g: 2.3,
    carbohidratos_g: 3.9,
    grasa_g: 0.4,
    fibra_g: 2.3,
    calcio_mg: 90,
    hierro_mg: 1.9,
    vitamina_a_mcg: 164,
    vitamina_c_mg: 21.2,
    folato_mcg: 48,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'economico',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/quelites.jpg',
    sustitutos_similares: ['alimento_020'],
    descripcion: 'Hojas comestibles prehispánicas, super nutritivas y ricas en calcio.',
  },
  {
    id: 'alimento_027',
    nombre: 'Verdolagas',
    nombres_regionales: ['Verdolaga', 'Portulaca'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza cocida (115g)',
    calorias: 20,
    proteina_g: 1.7,
    carbohidratos_g: 3.4,
    grasa_g: 0.2,
    fibra_g: 1.0,
    calcio_mg: 90,
    hierro_mg: 2.0,
    vitamina_a_mcg: 242,
    vitamina_c_mg: 25.0,
    folato_mcg: 12,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'economico',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/verdolagas.jpg',
    sustitutos_similares: ['alimento_026'],
    descripcion: 'Verdura tradicional mexicana rica en omega-3 vegetal y antioxidantes.',
  },
  {
    id: 'alimento_028',
    nombre: 'Espinacas',
    nombres_regionales: ['Espinaca'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1 taza cocida (180g)',
    calorias: 41,
    proteina_g: 5.4,
    carbohidratos_g: 6.8,
    grasa_g: 0.5,
    fibra_g: 4.3,
    calcio_mg: 245,
    hierro_mg: 6.4,
    vitamina_a_mcg: 943,
    vitamina_c_mg: 17.6,
    folato_mcg: 263,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/espinacas.jpg',
    sustitutos_similares: ['alimento_026', 'alimento_027'],
    descripcion: 'Verdura de hoja verde, excelente fuente de hierro y calcio.',
  },

  // ========== MÁS FRUTAS ==========
  {
    id: 'alimento_032',
    nombre: 'Guayaba',
    nombres_regionales: ['Guayaba', 'Guava'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '2 piezas pequeñas (110g)',
    calorias: 75,
    proteina_g: 2.6,
    carbohidratos_g: 15.7,
    grasa_g: 1.0,
    fibra_g: 5.4,
    calcio_mg: 20,
    hierro_mg: 0.3,
    vitamina_a_mcg: 34,
    vitamina_c_mg: 254.0,
    folato_mcg: 14,
    es_tradicional_mexicano: true,
    region_origen: ['Sur', 'Golfo', 'Pacífico'],
    temporada: ['Otoño', 'Invierno'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 31,
    carga_glucemica: 5,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/guayaba.jpg',
    sustitutos_similares: ['alimento_030'],
    descripcion: 'Fruta mexicana con más vitamina C que la naranja, excelente para el sistema inmune.',
  },
  {
    id: 'alimento_033',
    nombre: 'Tuna (nopal)',
    nombres_regionales: ['Tuna', 'Nochtli (náhuatl)', 'Higo chumbo'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '2 piezas medianas (150g)',
    calorias: 61,
    proteina_g: 1.1,
    carbohidratos_g: 14.3,
    grasa_g: 0.8,
    fibra_g: 5.4,
    calcio_mg: 83,
    hierro_mg: 0.5,
    vitamina_a_mcg: 7,
    vitamina_c_mg: 21.0,
    folato_mcg: 9,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Norte'],
    temporada: ['Verano'],
    costo_relativo: 'economico',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 35,
    carga_glucemica: 5,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/tuna.jpg',
    sustitutos_similares: ['alimento_030'],
    descripcion: 'Fruto del nopal, símbolo nacional. Rico en fibra y ayuda a regular glucosa.',
  },
  {
    id: 'alimento_034',
    nombre: 'Mamey',
    nombres_regionales: ['Mamey zapote', 'Mamey'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '1/2 taza (100g)',
    calorias: 124,
    proteina_g: 1.4,
    carbohidratos_g: 32.1,
    grasa_g: 0.5,
    fibra_g: 5.4,
    calcio_mg: 18,
    hierro_mg: 0.8,
    vitamina_a_mcg: 39,
    vitamina_c_mg: 23.0,
    folato_mcg: 14,
    es_tradicional_mexicano: true,
    region_origen: ['Sur', 'Golfo'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'moderado',
    disponibilidad: 'baja',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 44,
    carga_glucemica: 14,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/mamey.jpg',
    sustitutos_similares: ['alimento_031'],
    descripcion: 'Fruta tropical prehispánica, cremosa y dulce. Rica en vitaminas y minerales.',
  },
  {
    id: 'alimento_035',
    nombre: 'Tejocote',
    nombres_regionales: ['Tejocote', 'Texócotl (náhuatl)', 'Manzanita'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '3 piezas (105g)',
    calorias: 52,
    proteina_g: 0.7,
    carbohidratos_g: 13.2,
    grasa_g: 0.2,
    fibra_g: 4.2,
    calcio_mg: 16,
    hierro_mg: 0.6,
    vitamina_a_mcg: 12,
    vitamina_c_mg: 38.0,
    folato_mcg: 8,
    es_tradicional_mexicano: true,
    region_origen: ['Centro'],
    temporada: ['Otoño', 'Invierno'],
    costo_relativo: 'economico',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 36,
    carga_glucemica: 5,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/tejocote.jpg',
    sustitutos_similares: ['alimento_032'],
    descripcion: 'Fruta tradicional mexicana del otoño, esencial en ponche navideño.',
  },
  {
    id: 'alimento_036',
    nombre: 'Plátano macho',
    nombres_regionales: ['Plátano macho', 'Plátano para cocinar'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '1/3 taza cocido (80g)',
    calorias: 96,
    proteina_g: 0.8,
    carbohidratos_g: 25.0,
    grasa_g: 0.1,
    fibra_g: 1.8,
    calcio_mg: 2,
    hierro_mg: 0.5,
    vitamina_a_mcg: 56,
    vitamina_c_mg: 14.4,
    folato_mcg: 16,
    es_tradicional_mexicano: true,
    region_origen: ['Golfo', 'Sur'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 70,
    carga_glucemica: 17,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/platano-macho.jpg',
    sustitutos_similares: ['alimento_005'],
    descripcion: 'Versátil en cocina mexicana, rico en almidón resistente cuando está verde.',
  },

  // ========== CARNES ==========
  {
    id: 'alimento_060',
    nombre: 'Pechuga de pollo sin piel',
    nombres_regionales: ['Pechuga de pollo', 'Pollo'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_MUY_BAJO,
    cantidad_porcion: '30g',
    calorias: 49,
    proteina_g: 9.3,
    carbohidratos_g: 0,
    grasa_g: 1.0,
    fibra_g: 0,
    calcio_mg: 3,
    hierro_mg: 0.3,
    vitamina_a_mcg: 2,
    vitamina_c_mg: 0,
    folato_mcg: 1,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/pechuga-pollo.jpg',
    sustitutos_similares: ['alimento_061'],
    descripcion: 'Proteína magra por excelencia, muy popular en la cocina mexicana.',
  },
  {
    id: 'alimento_061',
    nombre: 'Pescado blanco (tilapia/mojarra)',
    nombres_regionales: ['Mojarra', 'Tilapia', 'Pescado blanco'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_MUY_BAJO,
    cantidad_porcion: '30g',
    calorias: 38,
    proteina_g: 7.8,
    carbohidratos_g: 0,
    grasa_g: 0.8,
    fibra_g: 0,
    calcio_mg: 4,
    hierro_mg: 0.2,
    vitamina_a_mcg: 1,
    vitamina_c_mg: 0,
    folato_mcg: 2,
    es_tradicional_mexicano: true,
    region_origen: ['Golfo', 'Pacífico'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: ['pescado'],
    imagen_url: '/images/alimentos/pescado-blanco.jpg',
    sustitutos_similares: ['alimento_060'],
    descripcion: 'Pescado muy popular en México, bajo en grasa y rico en proteína.',
  },
  {
    id: 'alimento_062',
    nombre: 'Atún en agua',
    nombres_regionales: ['Atún', 'Atún enlatado'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_MUY_BAJO,
    cantidad_porcion: '30g',
    calorias: 35,
    proteina_g: 8.2,
    carbohidratos_g: 0,
    grasa_g: 0.3,
    fibra_g: 0,
    calcio_mg: 4,
    hierro_mg: 0.4,
    vitamina_a_mcg: 1,
    vitamina_c_mg: 0,
    folato_mcg: 1,
    es_tradicional_mexicano: false,
    region_origen: ['Pacífico'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: ['pescado'],
    imagen_url: '/images/alimentos/atun-agua.jpg',
    sustitutos_similares: ['alimento_061'],
    descripcion: 'Excelente fuente de proteína magra y omega-3, muy práctico.',
  },

  // ========== LECHES ==========
  {
    id: 'alimento_070',
    nombre: 'Leche descremada',
    nombres_regionales: ['Leche sin grasa', 'Leche light'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LECHE_DESCREMADA,
    cantidad_porcion: '1 taza (240ml)',
    calorias: 83,
    proteina_g: 8.3,
    carbohidratos_g: 12.2,
    grasa_g: 0.2,
    fibra_g: 0,
    calcio_mg: 299,
    hierro_mg: 0.1,
    vitamina_a_mcg: 149,
    vitamina_c_mg: 0,
    folato_mcg: 12,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 32,
    carga_glucemica: 4,
    potencial_alergeno: ['lactosa', 'proteína de leche'],
    imagen_url: '/images/alimentos/leche-descremada.jpg',
    sustitutos_similares: ['alimento_071'],
    descripcion: 'Fuente excelente de calcio y proteína sin grasa añadida.',
  },
  {
    id: 'alimento_071',
    nombre: 'Leche de almendra sin azúcar',
    nombres_regionales: ['Leche de almendra', 'Bebida de almendra'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.LECHE_DESCREMADA,
    cantidad_porcion: '1 taza (240ml)',
    calorias: 30,
    proteina_g: 1.0,
    carbohidratos_g: 1.0,
    grasa_g: 2.5,
    fibra_g: 0.5,
    calcio_mg: 450,
    hierro_mg: 0.7,
    vitamina_a_mcg: 150,
    vitamina_c_mg: 0,
    folato_mcg: 0,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 25,
    carga_glucemica: 0,
    potencial_alergeno: ['frutos secos'],
    imagen_url: '/images/alimentos/leche-almendra.jpg',
    sustitutos_similares: ['alimento_070'],
    descripcion: 'Alternativa vegetal fortificada con calcio, baja en calorías.',
  },

  // ========== CEREALES CON GRASA ==========
  {
    id: 'alimento_007',
    nombre: 'Tamal de pollo (sin manteca)',
    nombres_regionales: ['Tamal', 'Tamalli (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_CON_GRASA,
    cantidad_porcion: '1 pieza pequeña (80g)',
    calorias: 153,
    proteina_g: 5.2,
    carbohidratos_g: 20.5,
    grasa_g: 5.8,
    fibra_g: 2.5,
    calcio_mg: 45,
    hierro_mg: 1.2,
    vitamina_a_mcg: 12,
    vitamina_c_mg: 2.0,
    folato_mcg: 18,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 58,
    carga_glucemica: 12,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/tamal.jpg',
    sustitutos_similares: ['alimento_001'],
    descripcion: 'Platillo prehispánico ceremonial, patrimonio cultural de México.',
  },
  {
    id: 'alimento_008',
    nombre: 'Gordita de maíz integral',
    nombres_regionales: ['Gordita', 'Gordita de horno'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CEREALES_CON_GRASA,
    cantidad_porcion: '1 pieza pequeña (50g)',
    calorias: 131,
    proteina_g: 3.2,
    carbohidratos_g: 19.8,
    grasa_g: 4.5,
    fibra_g: 2.8,
    calcio_mg: 35,
    hierro_mg: 0.9,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 12,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Norte'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 55,
    carga_glucemica: 11,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/gordita.jpg',
    sustitutos_similares: ['alimento_001', 'alimento_007'],
    descripcion: 'Tortilla gruesa tradicional mexicana, versátil para rellenos.',
  },

  // ========== GRASAS SIN PROTEÍNA ==========
  {
    id: 'alimento_042',
    nombre: 'Aceite de aguacate',
    nombres_regionales: ['Aceite de aguacate', 'Aceite de palta'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_SIN_PROTEINA,
    cantidad_porcion: '1 cucharadita (5ml)',
    calorias: 40,
    proteina_g: 0,
    carbohidratos_g: 0,
    grasa_g: 4.5,
    fibra_g: 0,
    calcio_mg: 0,
    hierro_mg: 0,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 0,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'caro',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/aceite-aguacate.jpg',
    sustitutos_similares: ['alimento_043'],
    descripcion: 'Aceite premium mexicano, excelente para cocinar a altas temperaturas.',
  },
  {
    id: 'alimento_043',
    nombre: 'Aceite de oliva extra virgen',
    nombres_regionales: ['Aceite de oliva', 'AOVE'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_SIN_PROTEINA,
    cantidad_porcion: '1 cucharadita (5ml)',
    calorias: 40,
    proteina_g: 0,
    carbohidratos_g: 0,
    grasa_g: 4.5,
    fibra_g: 0,
    calcio_mg: 0,
    hierro_mg: 0,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 0,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/aceite-oliva.jpg',
    sustitutos_similares: ['alimento_042'],
    descripcion: 'Grasa saludable rica en antioxidantes y ácidos grasos monoinsaturados.',
  },

  // ========== MÁS GRASAS CON PROTEÍNA ==========
  {
    id: 'alimento_044',
    nombre: 'Cacahuates naturales',
    nombres_regionales: ['Cacahuate', 'Maní', 'Tlalcacahuatl (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_CON_PROTEINA,
    cantidad_porcion: '10 piezas (14g)',
    calorias: 82,
    proteina_g: 3.3,
    carbohidratos_g: 3.0,
    grasa_g: 7.0,
    fibra_g: 1.2,
    calcio_mg: 13,
    hierro_mg: 0.4,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 34,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 14,
    carga_glucemica: 0,
    potencial_alergeno: ['cacahuates'],
    imagen_url: '/images/alimentos/cacahuates.jpg',
    sustitutos_similares: ['alimento_045', 'alimento_041'],
    descripcion: 'Leguminosa mexicana rica en proteína vegetal y grasas saludables.',
  },
  {
    id: 'alimento_045',
    nombre: 'Nueces de Castilla',
    nombres_regionales: ['Nuez', 'Nuez de Castilla'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_CON_PROTEINA,
    cantidad_porcion: '3 piezas (15g)',
    calorias: 98,
    proteina_g: 2.3,
    carbohidratos_g: 2.1,
    grasa_g: 9.8,
    fibra_g: 1.0,
    calcio_mg: 15,
    hierro_mg: 0.4,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0.2,
    folato_mcg: 15,
    es_tradicional_mexicano: false,
    region_origen: ['Norte'],
    temporada: ['Otoño', 'Invierno'],
    costo_relativo: 'caro',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 0,
    potencial_alergeno: ['frutos secos'],
    imagen_url: '/images/alimentos/nueces.jpg',
    sustitutos_similares: ['alimento_044', 'alimento_046'],
    descripcion: 'Rica en omega-3, antioxidantes y vitamina E. Excelente para salud cerebral.',
  },
  {
    id: 'alimento_046',
    nombre: 'Almendras',
    nombres_regionales: ['Almendra'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.GRASAS_CON_PROTEINA,
    cantidad_porcion: '7 piezas (14g)',
    calorias: 81,
    proteina_g: 3.0,
    carbohidratos_g: 3.1,
    grasa_g: 7.0,
    fibra_g: 1.7,
    calcio_mg: 38,
    hierro_mg: 0.5,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 7,
    es_tradicional_mexicano: false,
    region_origen: ['Norte'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 0,
    potencial_alergeno: ['frutos secos'],
    imagen_url: '/images/alimentos/almendras.jpg',
    sustitutos_similares: ['alimento_044', 'alimento_045'],
    descripcion: 'Excelente fuente de calcio, vitamina E y fibra.',
  },

  // ========== ALIMENTOS TRADICIONALES MEXICANOS ESPECIALES ==========
  {
    id: 'alimento_080',
    nombre: 'Huitlacoche',
    nombres_regionales: ['Huitlacoche', 'Cuitlacoche', 'Trufa mexicana'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.VERDURAS,
    cantidad_porcion: '1/2 taza (70g)',
    calorias: 25,
    proteina_g: 2.1,
    carbohidratos_g: 5.2,
    grasa_g: 0.3,
    fibra_g: 2.8,
    calcio_mg: 8,
    hierro_mg: 1.1,
    vitamina_a_mcg: 5,
    vitamina_c_mg: 3.5,
    folato_mcg: 32,
    es_tradicional_mexicano: true,
    region_origen: ['Centro', 'Sur'],
    temporada: ['Verano', 'Otoño'],
    costo_relativo: 'caro',
    disponibilidad: 'baja',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 15,
    carga_glucemica: 1,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/huitlacoche.jpg',
    sustitutos_similares: ['alimento_022'],
    descripcion: 'Hongo del maíz, considerado manjar prehispánico. Rico en proteína y fibra.',
  },
  {
    id: 'alimento_081',
    nombre: 'Chapulines tostados',
    nombres_regionales: ['Chapulín', 'Saltamontes', 'Chapolin (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_BAJO,
    cantidad_porcion: '30g',
    calorias: 121,
    proteina_g: 20.5,
    carbohidratos_g: 3.6,
    grasa_g: 3.2,
    fibra_g: 5.1,
    calcio_mg: 45,
    hierro_mg: 5.3,
    vitamina_a_mcg: 8,
    vitamina_c_mg: 0,
    folato_mcg: 15,
    es_tradicional_mexicano: true,
    region_origen: ['Oaxaca', 'Sur'],
    temporada: ['Verano'],
    costo_relativo: 'caro',
    disponibilidad: 'baja',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: ['crustáceos (sensibilidad cruzada)'],
    imagen_url: '/images/alimentos/chapulines.jpg',
    sustitutos_similares: ['alimento_060'],
    descripcion: 'Insecto comestible prehispánico, proteína sustentable. Muy rico en hierro.',
  },
  {
    id: 'alimento_082',
    nombre: 'Escamoles',
    nombres_regionales: ['Escamol', 'Caviar mexicano', 'Huevos de hormiga'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_MODERADO,
    cantidad_porcion: '30g',
    calorias: 78,
    proteina_g: 8.2,
    carbohidratos_g: 2.5,
    grasa_g: 4.1,
    fibra_g: 0,
    calcio_mg: 18,
    hierro_mg: 2.3,
    vitamina_a_mcg: 12,
    vitamina_c_mg: 0,
    folato_mcg: 8,
    es_tradicional_mexicano: true,
    region_origen: ['Centro'],
    temporada: ['Primavera'],
    costo_relativo: 'caro',
    disponibilidad: 'baja',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: ['crustáceos (sensibilidad cruzada)'],
    imagen_url: '/images/alimentos/escamoles.jpg',
    sustitutos_similares: ['alimento_060'],
    descripcion: 'Larvas de hormiga, manjar prehispánico de temporada. Alto en proteína.',
  },

  // ========== MÁS FRUTAS MEXICANAS ==========
  {
    id: 'alimento_037',
    nombre: 'Zapote negro',
    nombres_regionales: ['Zapote negro', 'Zapote prieto'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '1/2 taza (100g)',
    calorias: 80,
    proteina_g: 1.5,
    carbohidratos_g: 18.5,
    grasa_g: 0.3,
    fibra_g: 2.8,
    calcio_mg: 25,
    hierro_mg: 0.6,
    vitamina_a_mcg: 35,
    vitamina_c_mg: 19.0,
    folato_mcg: 12,
    es_tradicional_mexicano: true,
    region_origen: ['Golfo', 'Sur'],
    temporada: ['Otoño', 'Invierno'],
    costo_relativo: 'moderado',
    disponibilidad: 'baja',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 42,
    carga_glucemica: 8,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/zapote-negro.jpg',
    sustitutos_similares: ['alimento_034'],
    descripcion: 'Fruta prehispánica de sabor a chocolate, rica en vitamina C.',
  },
  {
    id: 'alimento_038',
    nombre: 'Chicozapote',
    nombres_regionales: ['Chicozapote', 'Zapotillo', 'Tzictli (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '1 pieza pequeña (100g)',
    calorias: 83,
    proteina_g: 0.4,
    carbohidratos_g: 20.0,
    grasa_g: 1.1,
    fibra_g: 5.3,
    calcio_mg: 21,
    hierro_mg: 0.8,
    vitamina_a_mcg: 3,
    vitamina_c_mg: 14.7,
    folato_mcg: 14,
    es_tradicional_mexicano: true,
    region_origen: ['Golfo', 'Península de Yucatán'],
    temporada: ['Primavera'],
    costo_relativo: 'moderado',
    disponibilidad: 'baja',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 40,
    carga_glucemica: 8,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/chicozapote.jpg',
    sustitutos_similares: ['alimento_034'],
    descripcion: 'Árbol que produce el chicle natural. Fruta dulce y energética.',
  },
  {
    id: 'alimento_039',
    nombre: 'Ciruela mexicana',
    nombres_regionales: ['Ciruela', 'Ciruela roja', 'Jocote'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.FRUTAS,
    cantidad_porcion: '3 piezas (90g)',
    calorias: 42,
    proteina_g: 0.6,
    carbohidratos_g: 10.4,
    grasa_g: 0.3,
    fibra_g: 1.4,
    calcio_mg: 5,
    hierro_mg: 0.2,
    vitamina_a_mcg: 32,
    vitamina_c_mg: 8.6,
    folato_mcg: 4,
    es_tradicional_mexicano: true,
    region_origen: ['Sur', 'Pacífico'],
    temporada: ['Primavera', 'Verano'],
    costo_relativo: 'economico',
    disponibilidad: 'media',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 38,
    carga_glucemica: 4,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/ciruela.jpg',
    sustitutos_similares: ['alimento_032'],
    descripcion: 'Ciruela pequeña tradicional mexicana, refrescante y económica.',
  },

  // ========== AZÚCARES ==========
  {
    id: 'alimento_090',
    nombre: 'Miel de abeja natural',
    nombres_regionales: ['Miel', 'Miel de abeja', 'Necuhtli (náhuatl)'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.AZUCARES_SIN_GRASA,
    cantidad_porcion: '1 cucharada (21g)',
    calorias: 64,
    proteina_g: 0.1,
    carbohidratos_g: 17.3,
    grasa_g: 0,
    fibra_g: 0,
    calcio_mg: 1,
    hierro_mg: 0.1,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0.1,
    folato_mcg: 0,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 58,
    carga_glucemica: 10,
    potencial_alergeno: ['polen'],
    imagen_url: '/images/alimentos/miel.jpg',
    sustitutos_similares: ['alimento_091'],
    descripcion: 'Endulzante natural con propiedades antibacterianas y antioxidantes.',
  },
  {
    id: 'alimento_091',
    nombre: 'Piloncillo (panela)',
    nombres_regionales: ['Piloncillo', 'Panela', 'Panocha'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.AZUCARES_SIN_GRASA,
    cantidad_porcion: '1 cucharada (20g)',
    calorias: 76,
    proteina_g: 0.1,
    carbohidratos_g: 19.5,
    grasa_g: 0,
    fibra_g: 0,
    calcio_mg: 18,
    hierro_mg: 0.7,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 0,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'economico',
    disponibilidad: 'alta',
    nivel_procesamiento: 'procesado',
    indice_glucemico: 65,
    carga_glucemica: 13,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/piloncillo.jpg',
    sustitutos_similares: ['alimento_090'],
    descripcion: 'Azúcar de caña sin refinar, conserva minerales. Tradicional en cocina mexicana.',
  },

  // ========== MÁS CARNES ==========
  {
    id: 'alimento_063',
    nombre: 'Carne de res magra (bistec)',
    nombres_regionales: ['Bistec', 'Carne de res'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_BAJO,
    cantidad_porcion: '30g',
    calorias: 52,
    proteina_g: 7.8,
    carbohidratos_g: 0,
    grasa_g: 2.1,
    fibra_g: 0,
    calcio_mg: 3,
    hierro_mg: 0.8,
    vitamina_a_mcg: 0,
    vitamina_c_mg: 0,
    folato_mcg: 2,
    es_tradicional_mexicano: false,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/bistec.jpg',
    sustitutos_similares: ['alimento_060', 'alimento_064'],
    descripcion: 'Excelente fuente de proteína, hierro y vitamina B12.',
  },
  {
    id: 'alimento_064',
    nombre: 'Lomo de cerdo',
    nombres_regionales: ['Lomo de cerdo', 'Cerdo'],
    categoria_equivalente: CATEGORIAS_EQUIVALENTES.CARNES_MODERADO,
    cantidad_porcion: '30g',
    calorias: 57,
    proteina_g: 7.5,
    carbohidratos_g: 0,
    grasa_g: 2.8,
    fibra_g: 0,
    calcio_mg: 2,
    hierro_mg: 0.3,
    vitamina_a_mcg: 1,
    vitamina_c_mg: 0,
    folato_mcg: 1,
    es_tradicional_mexicano: true,
    region_origen: ['Todo México'],
    temporada: ['Todo el año'],
    costo_relativo: 'moderado',
    disponibilidad: 'alta',
    nivel_procesamiento: 'minimo',
    indice_glucemico: 0,
    carga_glucemica: 0,
    potencial_alergeno: [],
    imagen_url: '/images/alimentos/lomo-cerdo.jpg',
    sustitutos_similares: ['alimento_063', 'alimento_060'],
    descripcion: 'Carne magra rica en tiamina y selenio. Base de muchos platillos mexicanos.',
  },
];

// Función helper para obtener alimentos por categoría
export const getAlimentosPorCategoria = (categoria) => {
  return ALIMENTOS_MEXICANOS.filter(
    (alimento) => alimento.categoria_equivalente === categoria
  );
};

// Función helper para buscar alimentos
export const buscarAlimentos = (termino) => {
  const terminoLower = termino.toLowerCase();
  return ALIMENTOS_MEXICANOS.filter(
    (alimento) =>
      alimento.nombre.toLowerCase().includes(terminoLower) ||
      alimento.nombres_regionales.some((nombre) =>
        nombre.toLowerCase().includes(terminoLower)
      ) ||
      alimento.region_origen.some((region) =>
        region.toLowerCase().includes(terminoLower)
      )
  );
};

// Función helper para obtener estadísticas
export const getEstadisticasAlimentos = () => {
  const totalAlimentos = ALIMENTOS_MEXICANOS.length;
  const alimentosTradicionales = ALIMENTOS_MEXICANOS.filter(
    (a) => a.es_tradicional_mexicano
  ).length;
  const categorias = new Set(
    ALIMENTOS_MEXICANOS.map((a) => a.categoria_equivalente)
  ).size;

  return {
    totalAlimentos,
    alimentosTradicionales,
    categorias,
    porcentajeTradicional: (
      (alimentosTradicionales / totalAlimentos) *
      100
    ).toFixed(1),
  };
};

export default ALIMENTOS_MEXICANOS;
